import React from "react";
import { Box, Typography } from "@mui/material";

/* Shared card heading with the accent bar used across all dashboard cards */
const CardTitle = ({ children, accent = "#5751E9" }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <Box
      sx={{
        width: 4,
        height: 18,
        borderRadius: "4px",
        backgroundColor: accent,
        flexShrink: 0,
      }}
    />
    <Typography
      variant="h6"
      sx={{ fontWeight: 700, color: "var(--app-text)", fontSize: "18px" }}
    >
      {children}
    </Typography>
  </Box>
);

export default CardTitle;
